var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _vm.profile
      ? _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            {
              staticClass: "active",
              class: { "on-mobile": _vm.$store.state.chat.isMobileMode },
              attrs: { id: "wrapper" }
            },
            [
              _c("div", { staticClass: "row" }, [
                !_vm.$store.state.chat.isMobileMode && _vm.isOnMobile
                  ? _c(
                      "div",
                      { staticClass: "col-fixed-90" },
                      [
                        _c(
                          "transition",
                          {
                            attrs: { "enter-active-class": "uk-animation-fade" }
                          },
                          [_c("sidebar")],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.chat.isMobileMode && _vm.isOnMobile
                  ? _c(
                      "div",
                      {
                        class: {
                          "fixe-sidebar": _vm.$store.state.chat.isMobileMode
                        }
                      },
                      [
                        _c(
                          "transition",
                          {
                            attrs: { "enter-active-class": "uk-animation-fade" }
                          },
                          [_c("sidebar-mobile")],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-fixed-listbar",
                    class: { "on-mobile": _vm.$store.state.chat.isMobileMode },
                    attrs: { id: "contect" }
                  },
                  [
                    _vm.isOnMobile
                      ? _c(
                          "transition",
                          { attrs: { name: "component-fade", mode: "out-in" } },
                          [_c("router-view")],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-lg-12 col-offset-msg",
                    class: { "on-mobile": _vm.$store.state.chat.isMobileMode },
                    attrs: { id: "chatbox" }
                  },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "component-fade", mode: "out-in" } },
                      [_vm.activeChatCustomer ? _c("chat-box") : _vm._e()],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "slide-fade" } },
                      [_vm.customerContact ? _c("profile-info") : _vm._e()],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 